import UserItem from '@/models/UserItem'
import { callApi } from '@/_core/api/apiWrapper'
// import UserBookMock from '@/mocks/book/user-book'
// import UserVprMock from '@/mocks/vpr/user_vrp'
// import { USER_ITEM_TYPE_BOOK } from '@/config'

export const getUserItems = async (params, next = null) => {
  const url = 'catalog/'

  const request = next
    ? () => callApi({ method: 'get', url: next, remote: true })
    : () => callApi({ method: 'get', url, params })

  const response = await request()

  if (response.data) response.data.results = response.data.results.map(el => new UserItem(el))
  return response
}

export const getUserItem = async (type, id) => {
  if (!type || !id) return
  const response = await callApi({
    method: 'get',
    url: 'user-item/',
    params: { type, id }
  })
  // const response = await new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({
  //       data: type === USER_ITEM_TYPE_BOOK ? { ...UserBookMock } : { ...UserVprMock }
  //     })
  //   }, 300)
  // })
  if (response.data) response.data = new UserItem(response.data)
  return response
}

export const setFavorite = async (data) => {
  if (!data) return
  const response = callApi({
    method: 'post',
    url: 'make-favorite/',
    data
  })
  return response
}
